<!-- Server-converted levels: never signed, never recomputed here. -->
<script setup lang="ts">
import MoneyAmount from '@/app/components/MoneyAmount.vue'
import { Card } from '@taler/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import LoanSummaryIcon from '@/features/loans/components/LoanSummaryIcon.vue'
import type { LoanPortfolio } from '../internal/types.ts'

const props = defineProps<{ summary: LoanPortfolio }>()
const { t } = useI18n()

const cards = computed(() => [
  {
    key: 'totalOutstanding',
    kind: 'outstanding' as const,
    label: t('loans.summary.totalOutstanding'),
    value: props.summary.totalOutstanding,
  },
  {
    key: 'monthlyPayments',
    kind: 'monthly' as const,
    label: t('loans.summary.monthlyPayments'),
    value: props.summary.monthlyPayments,
  },
  {
    key: 'estimatedRemainingInterest',
    kind: 'interest' as const,
    label: t('loans.summary.estimatedInterest'),
    value: props.summary.estimatedRemainingInterest,
  },
])
</script>

<template>
  <div class="grid grid-cols-3 gap-[var(--space-cell)]">
    <Card v-for="card in cards" :key="card.key" class="flex min-w-0 flex-col gap-[var(--space-cell)]">
      <span
        aria-hidden="true"
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-[var(--radius-control)] bg-[color:color-mix(in_srgb,var(--color-accent)_12%,transparent)] text-[color:var(--color-accent)]"
      >
        <LoanSummaryIcon :kind="card.kind" />
      </span>
      <dl class="flex min-w-0 flex-col gap-[var(--space-cell)]">
        <dt class="truncate text-[length:var(--text-step-2)] text-[color:var(--color-text-muted)]">
          {{ card.label }}
        </dt>
        <dd class="truncate text-[color:var(--color-text)]">
          <MoneyAmount :value="card.value" size="hero" />
        </dd>
      </dl>
    </Card>
  </div>
</template>
